/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RibbonIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACNUlEQVR4nMVVO4sUQRA+xDeIiYkiIoji4y8IqwayYHdVzUlv1bDIauAGgqkiBpv5WB/scYGhGnoamJgZHv4DBT3vEPUUTxFE1ET2pOZxMze3Z89Mcg0Nu1Xd3/dVVVfN2NhaLmPMVosysMTzQDJnUfqW5CEQ/wCUBf3f7XY31CYA4idAsvi/bZEnaoFbK0eAZOgnkN8A7nBpYA0ZUCaji7QENGOJu6fGw/1B0N5tiE8CytOcgKElfqwp9StH6S9TSPxstYsArXMW5W8umkEJAv6SA58HgG2NTmezJb4LxF/VryKazeamRNBgSRDyOy8BEH/PIuCrCcidlfnnm3EUsitNlUV56ydAfpCCIPKx2CYLI17Pp9yd2YSgXyICuZWCGAqPrkYAJB+ztMrrxHa/DMFcrmgXRxU+yfc19TnntqeFtsjfvAQW+UNWZHnZaDTWO+c2WpTrWnRNjYKrLTpPciUjlc8lCHKvgiJV93q93rqR0ULrOJD8yp2/4SVwzm0BlKlCFz+3gZxI5w4R79OIAPlP2s0qrNJc0vYvdHNal58F25CID5UGXkaCMumbRYD8qBY4ER9w7sweIL6tHawjWkd11HTIs5bkvXZ3ELR3IvLe6uqDVjv6BpB0jAl3RBvD0wbDC2Y8PBjXgc8C8hs9W5nAIl/2piery6U6BBMVCPxTtLiSp7pYKOiLaK+wy1QdgumcwlcGQ0p9+lttOYLpygTJ/JkBkvM6Lop+takvPhOP7jVZ/wAuL8nwHCMujAAAAABJRU5ErkJggg==)
 */
export const RibbonIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.89 11.79A3 3 0 1 0 13.1 6.2a3 3 0 0 0-2.22 5.58Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M11.91 16.43a.66.66 0 0 0-.16.08 3.16 3.16 0 0 1-2.85.27 3.14 3.14 0 0 1-1.88-2.16.67.67 0 0 0-.5-.49A3.14 3.14 0 0 1 4.5 9.45a.67.67 0 0 0 0-.7 3.14 3.14 0 0 1 1.88-4.73.67.67 0 0 0 .49-.5 3.14 3.14 0 0 1 4.68-2.02c.22.13.5.13.7 0a3.14 3.14 0 0 1 4.73 1.88c.07.24.26.44.5.49a3.14 3.14 0 0 1 2.02 4.68.67.67 0 0 0 0 .7 3.14 3.14 0 0 1-1.88 4.73.67.67 0 0 0-.49.5 3.14 3.14 0 0 1-4.68 2.02.66.66 0 0 0-.54-.07Zm-1.76-2.79a5 5 0 1 0 3.7-9.28 5 5 0 0 0-3.7 9.28Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.11 17.46a4.13 4.13 0 0 1-5.35-1.1l-.57 5.5a1 1 0 0 0 1.47.99l4.1-2.22a.5.5 0 0 1 .48 0l4.1 2.22a1 1 0 0 0 1.47-.98l-.56-5.42a4.12 4.12 0 0 1-5.14 1Z"
        className={colorClass}
      />
    </svg>
  );
};
